import Kfit from 'integrations/Kfit';

const getPaymentLink = props =>
  Kfit.get(`/v7/outlets/${props.outletId}/payment_link`, props).then(
    res => res
  );

export default getPaymentLink;
